import { Pipe, PipeTransform } from '@angular/core';
import { TranslatedString, untranslatedString } from 'models/translated-string';

/**
 * Pipe that marks a string as intentionally untranslated.
 * Use sparingly - only for symbols, units, or content that should not be translated.
 *
 * Usage: {{ '100g' | untranslated }}
 */
@Pipe({
  name: 'untranslated',
  pure: true,
  standalone: false
})
export class UntranslatedPipe implements PipeTransform {
  transform(value: string): TranslatedString {
    return untranslatedString(value);
  }
}
